import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-full flex flex-row py-6 text-white font-bold uppercase text-2xl [text-shadow:_2px_2px_0_rgb(155_155_155_/_60%)]" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "container w-full mx-auto" }
const _hoisted_4 = { class: "relative w-full shadow-lg rounded-lg bg-white px-4 py-3 pb-5" }
const _hoisted_5 = { class: "container mx-auto block w-full mt-4 space-y-4" }
const _hoisted_6 = { class: "w-full flex flex-col text-center md:flex-row gap-2" }
const _hoisted_7 = { class: "w-full flex flex-col" }
const _hoisted_8 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-3 text-sm pb-6 bg-white" }
const _hoisted_9 = { class: "p-3 w-full h-full bg-gray-50 shadow-xl border border-gray-200 rounded-md text-center flex flex-col" }
const _hoisted_10 = { class: "flex flex-col w-full space-y-2 flex-grow" }
const _hoisted_11 = { class: "w-full aspect-square overflow-hidden rounded-lg border border-gray-300" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "font-semibold line-clamp-1" }
const _hoisted_14 = { class: "text-gray-600 text-sm line-clamp-2" }
const _hoisted_15 = { class: "w-full flex flex-col mt-auto" }
const _hoisted_16 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputGroup = _resolveComponent("InputGroup")!
  const _component_DataView = _resolveComponent("DataView")!
  const _component_CommonPrivateView = _resolveComponent("CommonPrivateView")!
  const _component_BlockUI = _resolveComponent("BlockUI")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_CommonPrivateView, null, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.usuarioEmpresa)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.usuarioEmpresa.empresa.razonSocial), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex items-center justify-between font-semibold text-lg" }, " PRODUCTOS ", -1)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_router_link, {
                  to: "/producto",
                  class: "cursor-pointer py-2 px-4 rounded border border-green-600 bg-white text-green-600 hover:bg-green-800 hover:text-white"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'plus'] }),
                    _cache[1] || (_cache[1] = _createTextVNode(" AGREGAR PRODUCTO "))
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_InputGroup, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputText, {
                      onKeyup: _ctx.filtrar,
                      modelValue: _ctx.filtroTexto,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filtroTexto) = $event)),
                      placeholder: "Buscar...",
                      class: "input-group-base bg-gray-50"
                    }, null, 8, ["onKeyup", "modelValue"]),
                    _createVNode(_component_Button, {
                      onClick: _ctx.limpiarFiltro,
                      icon: "pi pi-times",
                      class: "border borde-red-700 bg-red-700 text-white hover:bg-transparent hover:text-red-700 hover:border-red-700"
                    }, null, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_DataView, {
                value: _ctx.productosFiltrados,
                paginator: "",
                rows: 16,
                alwaysShowPaginator: false,
                dataKey: "item.id"
              }, {
                empty: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createElementVNode("div", { class: "grid grid-cols-1 text-2xl font-semibold text-center text-gray-500 min-h-32 bg-white" }, " No hay productos creados ", -1)
                ])),
                list: _withCtx((slotProps) => [
                  _createElementVNode("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProps.items, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("img", {
                                src: item.previewFotoFile,
                                class: "w-full h-full object-cover object-center"
                              }, null, 8, _hoisted_12)
                            ]),
                            _createElementVNode("div", _hoisted_13, _toDisplayString(item.descripcion), 1),
                            _createElementVNode("div", _hoisted_14, _toDisplayString(item.detalles || ' '), 1),
                            _createElementVNode("div", _hoisted_15, [
                              _createVNode(_component_router_link, {
                                to: '/producto/' + item.id,
                                class: "py-1 mt-2 block rounded border border-black bg-transparent text-black hover:bg-black hover:text-white cursor-pointer"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_font_awesome_icon, { icon: ['fas', 'pencil'] }),
                                  _cache[3] || (_cache[3] = _createTextVNode(" EDITAR "))
                                ]),
                                _: 2
                              }, 1032, ["to"]),
                              _createElementVNode("a", {
                                onClick: ($event: any) => (_ctx.eliminarProducto(item)),
                                class: "py-1 mt-2 block rounded border border-red-500 bg-transparent text-red-500 hover:bg-red-500 hover:text-white cursor-pointer"
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: ['fas', 'user-minus'] }),
                                _cache[4] || (_cache[4] = _createTextVNode(" ELIMINAR "))
                              ], 8, _hoisted_16)
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              }, 8, ["value"])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_BlockUI, {
      blocked: _ctx.isSubmitting,
      fullScreen: ""
    }, null, 8, ["blocked"])
  ], 64))
}